module.exports = __webpack_public_path__ + "assets/menu-icon.6f1572640ae6d9cd0a86a30c6d626c7f.svg";